import api from "../middlware/api";
import { camelToSnake } from "../utils/CamelToSnake";
import { BASE_URL } from "../constants";

const base = `${BASE_URL}/api/v1`;

export const getAttendance = (params: Record<string, any> = {}) => {
  const query = new URLSearchParams(
    Object.entries(camelToSnake(params))
      .filter(([, v]) => v !== undefined && v !== null && v !== "")
      .map(([k, v]) => [k, String(v)])
  ).toString();
  return api.get(`${base}/attendance${query ? `?${query}` : ""}`);
};

export const createAttendance = (payload: Record<string, any>) =>
  api.post(`${base}/attendance`, camelToSnake(payload));

export const updateAttendance = (id: number, payload: Record<string, any>) =>
  api.put(`${base}/attendance/${id}`, camelToSnake(payload));

export const getAttendancePunches = (params: Record<string, any> = {}) => {
  const query = new URLSearchParams(
    Object.entries(camelToSnake(params))
      .filter(([, v]) => v !== undefined && v !== null && v !== "")
      .map(([k, v]) => [k, String(v)])
  ).toString();
  return api.get(`${base}/attendance/punches${query ? `?${query}` : ""}`);
};

export const getBiometricDevices = () =>
  api.get(`${base}/biometric-devices`);

export const createBiometricDevice = (payload: Record<string, any>) =>
  api.post(`${base}/biometric-devices`, camelToSnake(payload));

export const updateBiometricDevice = (id: number, payload: Record<string, any>) =>
  api.put(`${base}/biometric-devices/${id}`, camelToSnake(payload));

export const getDeviceMappings = (deviceId: number) =>
  api.get(`${base}/biometric-devices/${deviceId}/mappings`);

export const createDeviceMapping = (deviceId: number, payload: Record<string, any>) =>
  api.post(`${base}/biometric-devices/${deviceId}/mappings`, camelToSnake(payload));

export const deleteDeviceMapping = (mappingId: number) =>
  api.delete(`${base}/device-employee-mappings/${mappingId}`);
